"use strict";
/**
 * @file Created on 08.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NSimDummyCreatedDTO_1 = require("../model/NSimDummyCreatedDTO");

var NotificationDocConverter_1 = require("../NotificationDocConverter");

var NSimDummyCreatedDTOConverter_1 = require("./NSimDummyCreatedDTOConverter");

var NSimDummyProductConverterImpl_1 = require("./NSimDummyProductConverterImpl");
/**
 * @author Tomas Leity
 */


var NSimDummyCreatedDTOConverterImpl =
/*#__PURE__*/
function (_NSimDummyCreatedDTOC) {
  _inherits(NSimDummyCreatedDTOConverterImpl, _NSimDummyCreatedDTOC);

  /**
   * @param productObjectConverter
   */
  function NSimDummyCreatedDTOConverterImpl(productObjectConverter) {
    var _this;

    _classCallCheck(this, NSimDummyCreatedDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimDummyCreatedDTOConverterImpl).call(this));
    _this.productObjectConverter = productObjectConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NSimDummyCreatedDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NSimDummyCreatedDTO_1.NSimDummyCreatedDTO(NSimDummyCreatedDTO_1.NSimDummyCreatedDTO.schema.products.valueOf(conversions.asObjectList(source, 'products', function (obj) {
        return _this2.productObjectConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        products: conversions.asObjectArray(source, 'products', function (obj) {
          return _this3.productObjectConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NSimDummyCreatedDTOConverterImpl;
}(NSimDummyCreatedDTOConverter_1.NSimDummyCreatedDTOConverter);
/**
 * IOC Container qualifier
 */


NSimDummyCreatedDTOConverterImpl.QUALIFIER = {
  documentType: NSimDummyCreatedDTO_1.NSimDummyCreatedDTO.name
};
NSimDummyCreatedDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject(NSimDummyProductConverterImpl_1.NSimDummyProductConverterImpl.QUALIFIER)), __metadata("design:paramtypes", [NotificationDocConverter_1.NotificationDocConverter])], NSimDummyCreatedDTOConverterImpl);
exports.NSimDummyCreatedDTOConverterImpl = NSimDummyCreatedDTOConverterImpl;